import moment from 'moment';

const fromNow = (date) => {
  const mDate = moment(date);
  if (Math.abs(moment().diff(mDate)) < 44000) {
    return 'just now';
  }
  return moment(date).fromNow();
};

export { fromNow };
